/** The product mark — a small glyph standing exactly where a real logo would go. */
import { FALLBACK_MARK, MARKS, type MarkPart } from './productMeta';

function part(item: MarkPart, index: number): React.JSX.Element {
  const stroke = { stroke: 'currentColor', strokeWidth: item.width ?? 1.3, fill: 'none' };
  if (item.kind === 'circle') {
    return <circle key={index} cx={item.cx} cy={item.cy} r={item.r} {...stroke} />;
  }
  return (
    <path
      key={index}
      d={item.d}
      {...stroke}
      strokeLinecap={item.join === true ? undefined : 'round'}
      strokeLinejoin={item.join === true ? 'round' : undefined}
    />
  );
}

export function ProductMark({ productKey }: { productKey: string }): React.JSX.Element {
  const parts = MARKS[productKey] ?? FALLBACK_MARK;
  return (
    <span className="ds-sl__mark" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16">
        {parts.map(part)}
      </svg>
    </span>
  );
}
